module.exports = __webpack_public_path__ + "static/tana-ce5f240eb12bddaebdd35de24d61c8f2.png";